import React from 'react';

import { BETA_TAG_LABEL } from 'constants/uiConstants';

/**
 * A small "Beta" marker beside a nav or lens label (OP-2549). Outlined in the
 * label's own colour, so it reads on a selected (dark) item as well as an
 * unselected one.
 */
const BetaTag: React.FC = () => (
  <span className="ml-1.5 inline-block rounded border border-current px-1 align-middle text-xs font-semibold uppercase leading-4">
    {BETA_TAG_LABEL}
  </span>
);

export default BetaTag;
